module.exports = __webpack_public_path__ + "img/share_link.ad03959c.svg";